// extracted by mini-css-extract-plugin
export default {"card":"Ze_VTK9x1HQM5Uwlz8ZV","imageContainer":"GYpGBWFMGKEB5XoA806f","contentContainer":"iAUm6PpG2jOADwixHhSf","carPercentage":"ZggO62IQOTmfdY0zeCov"};